module.exports = __webpack_public_path__ + "files/c50857b6196c4aa6f7d7fc499b7f78b6.png";